<template>
    <div class="section">
        <v-container class="px-10">
            <v-row cols="12" justify="center">
                <v-col cols="12" md="3" class="px-10">
                    <h1 class="mb-5">Channel-Agnostic Conversations</h1>
                    <div>
                        Yabbr’s Web Chat unifies communications from every touchpoint into a seamless, context-rich thread. Whether it’s text, image, email, or voice, your agents reply from the same interface—no more switching tools. Just efficient, human responses that feel personal every time.
                    </div>
                    <v-btn
                    class="btn-primary--outline rounded-pill mt-8"
                    outlined
                    large
                    :ripple="false"
                    href="/channels"
                    >
                    Channels
                        <v-icon>mdi-arrow-right-thin</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" md="4" class="px-10 d-flex align-center justify-center">
                    <v-img
                    src="../assets/img/omni-channel.png"
                    contain
                    max-width="600px"
                    alt="sitemap" 
                    
                     /> 
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    name: 'ChatAgnostic'
}
</script>

<style lang="scss">
.features {
    .v-list-item {
        .v-list-item__title {
            font-size: 1.2em;
            font-weight: bold;
        }
        .v-list-item__text {
            font-size: 1.1em;
        }
    }
}
</style>